"use strict";
exports.__esModule = true;
exports.WIDGET_TYPES = void 0;
exports.WIDGET_TYPES = ['BOOKING_WIDGET', 'POPUP_WIDGET', 'CALL_ME_WIDGET', 'ONLINE_SUPPORT_WIDGET'];
//# sourceMappingURL=widget-types.constant.js.map